import * as Sentry from '@sentry/vue'
import KeywordApi from '@/api/keyword'
import OpenAIConstants from '@/constant/openAI'
import TextUtils from '@/utils/textUtil'

// state
const _state = {
}

// getters
const _getters = {
}

// mutations
const mutations = {
}

// HELPERS
const getKeywordFromResult = (result) => {
  try {
    const noResult = !result || !result.data || !result.data.keywords ||
    !result.data.keywords[0] || !result.data.keywords[0].length
    if (noResult) return null

    return result.data.keywords[0]
  } catch (error) {
    Sentry.captureException(error)
    return null
  }
}
/**
 * @deprecated This function is deprecated because it exists in the `slides` module.
 * Use `slideTitle getters ` instead.
 */
const getCurrentSlideTitle = (rootState) => {
  try {
    const hasSlideTitle = rootState.slideActive && rootState.slideActive.title && rootState.slideActive.title.length > 0
    if (!hasSlideTitle) return null
    return rootState.slideActive.title
  } catch (error) {
    Sentry.captureException(error)
    return null
  }
}

const getSlideActiveOptionTitle = (slideOption) => {
  try {
    const hasTitle = slideOption && slideOption.title && slideOption.title.length > 0
    if (!hasTitle) return null

    return slideOption.title
  } catch (error) {
    Sentry.captureException(error)
    return null
  }
}

const getKeywordByString = async (rootState, purpose, slideOption) => {
  try {
    const isPurposeQuestionImage = purpose === OpenAIConstants.AI_KEYWORD_QUESTION_IMAGE_PURPOSE
    const isPurposeSlideOptionImage = purpose === OpenAIConstants.AI_KEYWORD_SLIDE_OPTION_IMAGE_PURPOSE
    const isPurposeMatchPairPromptImage = purpose === OpenAIConstants.AI_KEYWORD_MATCH_PAIR_PROMPT_IMAGE_PURPOSE
    const isPurposeMatchPairAnswerImage = purpose === OpenAIConstants.AI_KEYWORD_MATCH_PAIR_ANSWER_IMAGE_PURPOSE

    let string
    if (isPurposeQuestionImage) {
      string = getCurrentSlideTitle(rootState)
    }
    if (isPurposeSlideOptionImage) {
      string = getSlideActiveOptionTitle(slideOption)
    }
    if (isPurposeMatchPairPromptImage) {
      string = slideOption.title
    }
    if (isPurposeMatchPairAnswerImage) {
      string = slideOption.pairTitle
    }
    const numberOfWordsInString = await TextUtils.countNumberOfWordsInString(string)

    let keyword
    if (numberOfWordsInString < 3) {
      keyword = string
    } else {
      const result = await KeywordApi.getAISuggestedKeywordByString({ string })
      keyword = getKeywordFromResult(result)
    }
    return keyword
  } catch (error) {
    Sentry.captureException(error)
    return null
  }
}

const getKeyWordBySlideContent = async (rootState, purpose) => {
  try {
    const result = await KeywordApi.getAISuggestedKeywordByContent({
      type: OpenAIConstants.TYPE_SLIDE,
      id: rootState.slideActive.id,
      purpose,
    })

    return getKeywordFromResult(result)
  } catch (error) {
    Sentry.captureException(error)
    return null
  }
}

// actions
const actions = {
  async getAISuggestedKeywordByPurposeAction({ rootState }, params) {
    try {
      const { purpose, slideOption } = params
      if (!purpose) return null

      const types = [OpenAIConstants.AI_KEYWORD_QUESTION_IMAGE_PURPOSE,
        OpenAIConstants.AI_KEYWORD_SLIDE_OPTION_IMAGE_PURPOSE,
        OpenAIConstants.AI_KEYWORD_MATCH_PAIR_PROMPT_IMAGE_PURPOSE,
        OpenAIConstants.AI_KEYWORD_MATCH_PAIR_ANSWER_IMAGE_PURPOSE,
      ]
      const isGetByString = types.includes(purpose)

      let keyword

      if (isGetByString) {
        keyword = await getKeywordByString(rootState, purpose, slideOption)
      } else {
        keyword = await getKeyWordBySlideContent(rootState, purpose)
      }
      return keyword
    } catch (error) {
      Sentry.captureException(error)
      return null
    }
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
